import { TrackingEventName } from 'services/tracking/constants';
import { ConversationFilterIds } from '../constants/enums';

export const handleConversationFilterTracking = ({
  filterId,
  track,
  value
}: {
  filterId: string;
  track: (event: string, data?: Record<string, unknown>) => void;
  value: string | boolean;
}) => {
  if (filterId === ConversationFilterIds.status) {
    track(TrackingEventName.CampaignDashboardFilterConversationStatus, {
      status: value
    });
  }

  if (filterId === ConversationFilterIds.screeningStatus) {
    track(TrackingEventName.CampaignDashboardFilterScreeningStatus, {
      status: value
    });
  }
};
